import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';

import { NotificationService } from './notification.service';


export enum DocumentStatus {
    Success = 1,
    Error = 2,
    Info = 3,
    Warning = 4
}

@Injectable({
    providedIn: 'root'
})
export class MessageInterceptor implements HttpInterceptor {

    constructor(
        private notificationService: NotificationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req)
            .pipe(
                tap((result: any) => {
                    if (result instanceof HttpResponse && result.body && result.body.__messages) {
                        for (const message of result.body.__messages) {
                            switch (message.type) {
                                case DocumentStatus.Success:
                                    this.notificationService.success(message.text, message.title, 5000);
                                    break;
                                case DocumentStatus.Error:
                                    this.notificationService.error(message.text, message.title, 5000);
                                    break;
                                case DocumentStatus.Info:
                                    this.notificationService.info(message.text, message.title, 5000);
                                    break;
                                case DocumentStatus.Warning:
                                    this.notificationService.warning(message.text, message.title, 5000);
                                    break;
                                default:
                                    this.notificationService.error('Unknown status', null, 5000);
                                    break;
                            }
                        }
                        delete result.body.__messages;
                    }
                })
            );
    }
}
